import type { OnInit } from '@angular/core';
import { Component, inject } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { ApiLoaderComponent } from './core/api-loader/api-loader.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ApiLoaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  title = 'fe-qautos';

  titleService = inject(Title);
  metaService = inject(Meta);
  router = inject(Router);

  ngOnInit(): void {
    this.titleService.setTitle('Qautos Admin | Rental');
    this.metaService.updateTag({
      name: 'description',
      content: 'The premier ride experience',
    });
    localStorage.setItem('theme', 'light');
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => this.hideSplash(), 100);
      }
    });
  }

  hideSplash(): void {
    const SPLASH = document.getElementById('splash-screen');
    if (SPLASH) {
      SPLASH.style.opacity = '0';
      SPLASH.style.transition = 'opacity 0.3s ease';
      SPLASH.remove();
    }
  }
}
